// const params = new URLSearchParams({ page_size: "100" });
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import BaseTable from "../../../components/table/BaseTable";
import DateService from "../../../services/dateService";
import SelectFieldService from "../../../services/selectFieldService";
import { convertBoolenValueToZero } from "../../../helpers/methods";
import { useGetPersonClausesHistory } from "../../../services/clausesService";


export function ClausesHistoryTab({ personId }) {
    const { t } = useTranslation();

    const {data: clausesData, isLoading} = useGetPersonClausesHistory(new URLSearchParams({persclau_person:personId, page_size:100, }))
    
    const HEADERS = [
        t("clients.PersonClausesDialog.table.created"),
        t("clients.PersonClausesDialog.table.clause_name"),
        t("clients.PersonClausesDialog.table.persclau_decision"),
        t("clients.PersonClausesDialog.table.persclau_text"),
        t("clients.PersonClausesDialog.table.creator"),
        t("clients.PersonClausesDialog.table.persclau_comment"),
    ];

    const rows = isLoading ? 
        [] : 
        clausesData.results.map((row) => ({
            rowId: row.id,
            data: [
                DateService.convertDatetimeFromBackendToFormatYYYYMMDD_hhmmss(row.created),
                row.clause_name,
                SelectFieldService.getLabelOptionsYesOrNo(row.persclau_decision),
                row.persclau_text,
                row.creator,
                row.persclau_comment,
            ],
        }));


    return (
        <BaseTable
            stickyHeader={false}
            headers={HEADERS}
            rows={rows}
            showEditButton={false}
            showDeleteButton={false}
            sortable={false}
            hiddenColumns={[]}
            selectedRows={[]}
        />
    )

}
